import { FieldMetadata, useInputControl } from '@conform-to/react'
import { z } from 'zod'

import { IconMapPin } from '~/components'
import { SimplifiedMultiSelect } from '~/components/ui/input/select/shadcn-multi-select'

export const areasMultiSelectFormSchema = z.object({
  areas: z.array(z.string()),
})

export const partialAreasMultiSelectFormSchema =
  areasMultiSelectFormSchema.partial()

type AreasType = z.infer<typeof areasMultiSelectFormSchema>['areas']

type Options = React.ComponentProps<typeof SimplifiedMultiSelect>['options']

export const useAreasForm = (
  meta: FieldMetadata<AreasType>,
  changeWatchedArea?: (areas: string[]) => void,
) => {
  const control = useInputControl<AreasType>({
    ...meta,
    initialValue: Array.isArray(meta?.initialValue)
      ? meta.initialValue.filter((val): val is string => val !== undefined)
      : [],
  })

  const value = Array.isArray(control.value) ? control.value : []

  const onChange = (areas: string[]) => {
    changeWatchedArea?.(areas)
    control.change(areas)
  }

  return { value, onChange, name: meta.name }
}

type Props = {
  name: string
  options: Options
  ariaLabel?: string
  value: string[]
  onChange: (value: string[]) => void
}

export const AreasMultiSelectForm = ({
  name,
  options,
  ariaLabel,
  value,
  onChange,
}: Props) => {
  return (
    <SimplifiedMultiSelect
      ariaLabel={ariaLabel}
      hideSelectAll={false}
      isClearable
      maxCount={10}
      name={name}
      onValueChange={onChange}
      options={options}
      placeholder="エリアを選択"
      placeholderIcon={<IconMapPin color="black" />}
      singleLine
      value={value}
    />
  )
}
